import {
	IconBookOpen4Outline18,
	IconCircleDashedOutline18,
	IconCircleUserOutline18,
	IconCube2Outline18,
	IconInboxOutline18,
	IconStackPerspectiveOutline18,
	IconOffice3Outline18,
} from "nucleo-ui-outline-18"

import type { AiContextAttachment } from "@productlane/lib/src/ai"

import { contextMentionBadgeClasses } from "./context-mention-badge-classes"
import { splitContextMentionText } from "./context-mention-segments"

// The sent turn keeps only the type, so the transcript badge carries the mark
// for that type rather than the row's own avatar or status colour.
const TYPE_ICONS = {
	issue: IconCircleDashedOutline18,
	thread: IconInboxOutline18,
	project: IconCube2Outline18,
	article: IconBookOpen4Outline18,
	changelog: IconStackPerspectiveOutline18,
	user: IconCircleUserOutline18,
	contact: IconCircleUserOutline18,
	company: IconOffice3Outline18,
}

const MentionBadge = ({ attachment }: { attachment: AiContextAttachment }) => {
	const Icon = TYPE_ICONS[attachment.type]
	return (
		<span className={contextMentionBadgeClasses()}>
			<Icon className="h-3 w-3 flex-none" strokeWidth={1.5} />
			{attachment.prefix && (
				<span className="flex-none font-mono opacity-70">
					{attachment.prefix}
				</span>
			)}
			<span className="truncate">{attachment.label}</span>
		</span>
	)
}

export const ContextMentionMessageContent = ({
	content,
	attachments,
}: {
	content: string
	attachments: readonly AiContextAttachment[] | undefined
}) => (
	<>
		{splitContextMentionText(content, attachments).map((segment, index) =>
			segment.kind === "text" ? (
				<span key={index}>{segment.text}</span>
			) : (
				<MentionBadge key={index} attachment={segment.attachment} />
			),
		)}
	</>
)
